import MarkdownRender from 'LuxKit/MarkdownRender'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import { useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import Group from 'components/utils/Group'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  descriptionMarkdown: string
  facilitiesMarkdown?: string
  location?: string
  offerName: string
  propertyName: string
}

function FlashHotelAboutHotelVariantModal(props: Props) {
  const {
    descriptionMarkdown,
    facilitiesMarkdown,
    location,
    offerName,
    propertyName,
  } = props

  const intl = useIntl()

  return (
    <Modal
      title={intl.formatMessage({
        id: 'xw0bFrkoqlnQr3O6nhta',
        defaultMessage: 'About the hotel',
      })}
      height="full"
    >
      <Group direction="vertical" gap={20}>
        <Group direction="vertical" gap={8}>
          {location && <BodyTextBlock variant="large" startIcon={<LineMapMarkerIcon />}>
            {location}
          </BodyTextBlock>}
          <Heading variant="heading2">{propertyName}</Heading>
          <BodyText variant="large">{offerName}</BodyText>
        </Group>
        {facilitiesMarkdown && <Group direction="vertical" gap={12}>
          <HeadingTextBlock variant="heading4">
            {intl.formatMessage({
              id: '0fg36pUYVnw8tpAbEWcI',
              defaultMessage: 'Hotel Facilities',
            })}
          </HeadingTextBlock>
          <MarkdownRender type="compact" fontSize="large" content={facilitiesMarkdown} />
        </Group>}
        <MarkdownRender type="compact" content={descriptionMarkdown} />
      </Group>
    </Modal>
  )
}

export default FlashHotelAboutHotelVariantModal
